import C from 'actionTypes'

const defaultState = {
  blackDiamondError: false,
  boxError: false,
}

const blackDiamondError = (state = defaultState.blackDiamondError, action) => {
  switch (action.type) {
    case C.SET_BLACK_DIAMOND_ERROR:
      return {
        ...state,
        blackDiamondError: true,
      }

    default:
      return state
  }
}

const boxError = (state = defaultState.boxError, action) => {
  switch (action.type) {
    case C.SET_BOX_ERROR:
      return {
        ...state,
        boxError: true,
      }

    default:
      return state
  }
}

export default {
  blackDiamondError,
  boxError
}



// WEBPACK FOOTER //
// ./src/reducers/client/errors.js